import React, { useState } from 'react';

const MerchantRegistrationDebugTest = () => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const testMinimalData = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      // Test with absolute minimal data
      const formData = new FormData();
      
      // Only required fields based on the guide
      formData.append('business_name', 'Test Store');
      formData.append('legal_name', 'Test Legal Name');
      formData.append('cr_number', '1234567890');
      formData.append('contact_person', 'Test Person');
      formData.append('phone', '+966501234567');
      formData.append('email', 'test@example.com');
      formData.append('address', 'Test Address');
      formData.append('city', 'Riyadh');
      formData.append('business_category', 'restaurant');

      console.log('🧪 Testing minimal data:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await fetch('https://nodjswebhook.onrender.com/api/public/merchant-registration', {
        method: 'POST',
        body: formData
      });

      console.log('📡 Response status:', response.status);
      let result = await response.json();
      console.log('📡 Response data:', result);

      if (result.details && Array.isArray(result.details)) {
        console.log('❌ Validation errors:');
        result.details.forEach((detail, index) => {
          console.log(`${index + 1}. ${detail.path}: ${detail.msg} (value: ${detail.value})`);
        });
      }

      if (response.ok && result.success) {
        setResponse(result);
      } else {
        setError(result.error || 'Validation failed');
      }
    } catch (err) {
      console.error('Error testing minimal data:', err);
      setError('خطأ في الاتصال: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const testWithAllFields = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const formData = new FormData();
      
      // All possible fields from the guide
      formData.append('business_name', 'Test Store');
      formData.append('legal_name', 'Test Legal Name');
      formData.append('cr_number', '1234567890');
      formData.append('contact_person', 'Test Person');
      formData.append('phone', '+966501234567');
      formData.append('email', 'test@example.com');
      formData.append('address', 'Test Address');
      formData.append('city', 'Riyadh');
      formData.append('business_category', 'restaurant');
      formData.append('bank_account_iban', 'SA1234567890123456789012');
      formData.append('bank_account_holder', 'Test Account Holder');

      console.log('🧪 Testing with all fields:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await fetch('https://nodjswebhook.onrender.com/api/public/merchant-registration', {
        method: 'POST',
        body: formData
      });

      console.log('📡 Response status:', response.status);
      let result = await response.json();
      console.log('📡 Response data:', result);

      if (result.details && Array.isArray(result.details)) {
        console.log('❌ Validation errors:');
        result.details.forEach((detail, index) => {
          console.log(`${index + 1}. ${detail.path}: ${detail.msg} (value: ${detail.value})`);
        });
      }

      if (response.ok && result.success) {
        setResponse(result);
      } else {
        setError(result.error || 'Validation failed');
      }
    } catch (err) {
      console.error('Error testing with all fields:', err);
      setError('خطأ في الاتصال: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const testWithOffersArray = async () => {
    setLoading(true);
    setError(null);
    setResponse(null);

    try {
      const formData = new FormData();
      
      // Basic fields
      formData.append('business_name', 'Test Store');
      formData.append('legal_name', 'Test Legal Name');
      formData.append('cr_number', '1234567890');
      formData.append('contact_person', 'Test Person');
      formData.append('phone', '+966501234567');
      formData.append('email', 'test@example.com');
      formData.append('address', 'Test Address');
      formData.append('city', 'Riyadh');
      formData.append('business_category', 'restaurant');

      // Try different offers format
      formData.append('offers', '[]'); // Empty array as string
      formData.append('gallery_metadata', '[]'); // Empty array as string

      console.log('🧪 Testing with offers array format:');
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      const response = await fetch('https://nodjswebhook.onrender.com/api/public/merchant-registration', {
        method: 'POST',
        body: formData
      });

      console.log('📡 Response status:', response.status);
      let result = await response.json();
      console.log('📡 Response data:', result);

      if (result.details && Array.isArray(result.details)) {
        console.log('❌ Validation errors:');
        result.details.forEach((detail, index) => {
          console.log(`${index + 1}. ${detail.path}: ${detail.msg} (value: ${detail.value})`);
        });
      }

      if (response.ok && result.success) {
        setResponse(result);
      } else {
        setError(result.error || 'Validation failed');
      }
    } catch (err) {
      console.error('Error testing with offers array:', err);
      setError('خطأ في الاتصال: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
      <h3 className="text-lg font-semibold mb-4 dark:text-gray-100">
        🔍 اختبار API تشخيصي متقدم
      </h3>
      
      <div className="space-y-2">
        <button
          onClick={testMinimalData}
          disabled={loading}
          className="w-full px-4 py-2 bg-red-600 text-white font-medium rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
        >
          {loading ? 'جاري الاختبار...' : 'اختبار البيانات الأساسية فقط'}
        </button>
        
        <button
          onClick={testWithAllFields}
          disabled={loading}
          className="w-full px-4 py-2 bg-yellow-600 text-white font-medium rounded-md hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
        >
          {loading ? 'جاري الاختبار...' : 'اختبار مع جميع الحقول'}
        </button>
        
        <button
          onClick={testWithOffersArray}
          disabled={loading}
          className="w-full px-4 py-2 bg-purple-600 text-white font-medium rounded-md hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 disabled:opacity-50"
        >
          {loading ? 'جاري الاختبار...' : 'اختبار مع تنسيق العروض'}
        </button>
      </div>

      {response && (
        <div className="mt-4 p-3 bg-green-100 text-green-800 rounded-md dark:bg-green-900 dark:text-green-200">
          <p className="font-semibold">✅ نجح الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}

      {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-800 rounded-md dark:bg-red-900 dark:text-red-200">
          <p className="font-semibold">❌ فشل الاختبار:</p>
          <pre className="whitespace-pre-wrap text-sm">{error}</pre>
        </div>
      )}
    </div>
  );
};

export default MerchantRegistrationDebugTest;
